import { piniaGlobal } from './global';
import { piniaWorkerNotice } from './workerNotice';
import { piniaDistributorNotice } from './distributorNotice';
import { piniaRequestMap } from './requestMap';
import { piniaStoreWorkProcess } from './storeWorkProcess';
import { piniaBarogoNotice } from './barogoNotice';
import { piniaWorkerAllocate } from './workerAllocate';
import { piniaMemberCompanyInquiry } from './memberCompanyInquiry';
import { piniaLocationControl } from './locationControl';
import { piniaBaromoneyTransferSetting } from './baromoneyTransferSetting';
import { piniaStats } from './stats';
import { piniaHubBaromoney } from './hubBaromoney';
import { piniaHubBaromoneyDailyDetail } from './hubBaromoneyDailyDetail';
import { piniaInvoice } from './invoice';
import { piniaStoreBaromoney } from './storeBaromoney';
import { piniaStoreBaromoneyDailyDetail } from './storeBaromoneyDailyDetail';
/**
 * 피니아 스토어 구조
 */
export const setPStore = () => ({
    piniaGlobal: piniaGlobal(),
    /** 총판장공지사항 */
    piniaDistributorNotice: piniaDistributorNotice(),
    /** 라이더 공지사항 */
    piniaWorkerNotice: piniaWorkerNotice(),
    /** 상점 업무처리 */
    piniaStoreWorkProcess: piniaStoreWorkProcess(),
    /** 바로고 공지사항 */
    piniaBarogoNotice: piniaBarogoNotice(),
    /** 세부지명 요청 */
    piniaRequestMap: piniaRequestMap(),
    /** 라이더 배차 */
    piniaWorkerAllocate: piniaWorkerAllocate(),
    /** 출발도착관제 */
    piniaLocationControl: piniaLocationControl(),
    /** 회원사 업무문의 */
    piniaMemberCompanyInquiry: piniaMemberCompanyInquiry(),
    /** 캐쉬 이동 설정 */
    piniaBaromoneyTransferSetting: piniaBaromoneyTransferSetting(),
    /** 상점 통계 */
    piniaStats: piniaStats(),
    /** 통계 > 허브 바로머니 */
    piniaHubBaromoney: piniaHubBaromoney(),
    /** 통계 > 허브 바로머니 > 일별 상세 */
    piniaHubBaromoneyDailyDetail: piniaHubBaromoneyDailyDetail(),
    /** 통계 > 상점 바로머니 */
    piniaStoreBaromoney: piniaStoreBaromoney(),
    /** 통계 > 상점 바로머니 > 일별 상세 */
    piniaStoreBaromoneyDailyDetail: piniaStoreBaromoneyDailyDetail(),
    /** 통계 > Invoice내역 */
    piniaInvoice: piniaInvoice(),
});
/** 피니아 스토어 최상위 객체 */
// eslint-disable-next-line import/no-mutable-exports
export let pStore = {};
/**
 * 초기화
 */
export const initPStore = () => {
    pStore = setPStore();
    window.pStore = pStore;
};
